import { DataSource } from '@angular/cdk/collections';
import { EventEmitter, Injector } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/api/api.service';

/**
 * Abstract class to create a DataSource for the table to retrieve data from server.
 */
export abstract class TableDataSource implements DataSource<any> {
  paginatedGet$: Observable<any>;
  isLoading$: Observable<boolean>;
  /**
   * Emit page index to reset table to a particular page (page 1 is index 0)
   */
  reloadData = new EventEmitter<any>();
  api: ApiService;
  protected paginatedGet = new ReplaySubject<any>();
  protected isLoading = new BehaviorSubject<boolean>(false);

  constructor(injector: Injector) {
    this.api = injector.get(ApiService);
    this.paginatedGet$ = this.paginatedGet.asObservable();
    this.isLoading$ = this.isLoading.asObservable();
  }

  /**
   * Used by mat-table to load data rows
   */
  connect(): Observable<any[]> {
    return this.paginatedGet.asObservable().pipe(map((val) => val.data));
  }

  disconnect(): void {
    this.isLoading.complete();
    this.paginatedGet.complete();
  }

  /**
   * Life cycle hook before data is loaded
   */
  protected onLoadDataStart(): void {
    this.isLoading.next(true);
  }

  /**
   * Life cycle hook after data has been loaded
   */
  protected onLoadDataEnd(): void {
    this.isLoading.next(false);
  }

  /**
   * Loads the data from the server and pushes it to the `paginatedGet` RelaySubject.
   *
   * @param params The parameters for the request.
   */
  abstract loadData(params: any, options?: any): void;
}
